import React, { useState } from 'react';
import Navbar from './components/layout/Navbar';
import HeroSlider from './components/home/HeroSlider';
import ProductCarousel from './components/home/ProductCarousel';
import Categories from './components/home/Categories';
import Features from './components/home/Features';
import NewArrivals from './components/home/NewArrivals';
import TopRated from './components/home/TopRated';
import BestSelling from './components/home/BestSelling';
import Footer from './components/layout/Footer';
import Newsletter from './components/layout/Newsletter';
import BottomNav from './components/layout/BottomNav';
import ActiveSalePopup from './components/layout/ActiveSalePopup';
import Preloader from './components/layout/Preloader';
import TopPromoBar from './components/layout/TopPromoBar';
import GlobalOrderDeliveredPopup from './components/layout/GlobalOrderDeliveredPopup';
import WhatsAppButton from './components/layout/WhatsAppButton';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import WishlistPage from './pages/WishlistPage';
import CookiesPage from './pages/CookiesPage';
import SustainabilityPage from './pages/SustainabilityPage';
import UserDashboard from './pages/UserDashboard';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ShopPage from './pages/ShopPage';
import CollectionsPage from './pages/CollectionsPage';
import CheckoutPage from './pages/CheckoutPage';
import ProductDetailsPage from './pages/ProductDetailsPage';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Session Validation: Clear persistent token/user when browser restart or new session is detected
if (typeof window !== 'undefined' && !sessionStorage.getItem('session_active')) {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  sessionStorage.setItem('session_active', 'true');
}

gsap.registerPlugin(ScrollTrigger);

const Home = () => (
  <>
    <HeroSlider />
    <ProductCarousel />
    <Categories />
    <NewArrivals />
    <TopRated />
    <BestSelling />
    <Features />
  </>
);

const AppContent = () => {
  const location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [toast, setToast] = useState(null);
  const [isPreloading, setIsPreloading] = useState(true);

  // Login required is now handled by Navbar.jsx which opens AuthModal

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
    ScrollTrigger.getAll().forEach(st => st.kill());
    ScrollTrigger.refresh();
  }, [location.pathname]);

  return (
    <div className="App">
      {isPreloading && <Preloader onComplete={() => setIsPreloading(false)} />}
      
      {/* Toast Notification */}
      {toast && (
        <div style={{
          position: 'fixed', top: '90px', left: '50%', transform: 'translateX(-50%)',
          background: '#121212', color: '#d4af37', border: '1px solid rgba(212, 175, 55,0.6)',
          padding: '12px 28px', borderRadius: '8px', zIndex: 99999,
          fontFamily: 'sans-serif', fontSize: '14px', letterSpacing: '0.5px',
          boxShadow: '0 8px 32px rgba(255, 255, 255, 0.50)', whiteSpace: 'nowrap',
          animation: 'fadeIn 0.3s ease'
        }}>
          🔐 {toast}
        </div>
      )}
      <div className="bg-container">
      </div>

      <TopPromoBar />
      <GlobalOrderDeliveredPopup />
      <Navbar />
      <main className="app-main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/terms-of-use" element={<TermsPage />} />
          <Route path="/cookies-policy" element={<CookiesPage />} />
          <Route path="/sustainability" element={<SustainabilityPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/profile" element={<UserDashboard />} />
          <Route path="/profile/:tab" element={<UserDashboard />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/collections" element={<CollectionsPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/product/:productId" element={<ProductDetailsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </main>
      <Newsletter />
      <Footer />
      <ActiveSalePopup />
      <BottomNav />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
